import {GenericWebhook} from 'src/components/Webhooks/WebhooksTable';

import {
  EventTriggeringConditionType,
  TriggerScopeType,
} from '../../../../generated/graphql';

export type OptionType = {
  label: string;
  value: string;
};

export type JobName = {
  name: string;
  alias: string;
};

export type Queue = {
  Name?: string;
  ID?: string;
};

export type TriggerScope = {
  scope: TriggerScopeType;
  id: string;
};

export type QueueJobTriggeredAction = {
  queue: Queue;
  template: string;
};

export type GenericWebhookTriggeredAction = {
  genericWebhook: GenericWebhook;
  requestPayload: string;
  entityName: string;
};

export type NotificationTriggeredAction = {
  integrationID: string;
  entityName: string;
  channelName: string;
};

export type TriggeredAction = {
  actionType: TriggeredActionType;
  actionConfig:
    | QueueJobTriggeredAction
    | NotificationTriggeredAction
    | GenericWebhookTriggeredAction;
};

export type TriggeredActionType =
  | 'QueueJobTriggeredAction'
  | 'NotificationTriggeredAction'
  | 'GenericWebhookTriggeredAction';

export function isQueueJobTriggeredAction(
  triggerActionConfig:
    | QueueJobTriggeredAction
    | NotificationTriggeredAction
    | GenericWebhookTriggeredAction
): triggerActionConfig is QueueJobTriggeredAction {
  return (triggerActionConfig as QueueJobTriggeredAction).queue !== undefined;
}

export function isGenericWebhookTriggeredAction(
  triggerActionConfig:
    | QueueJobTriggeredAction
    | NotificationTriggeredAction
    | GenericWebhookTriggeredAction
): triggerActionConfig is GenericWebhookTriggeredAction {
  return (
    (triggerActionConfig as GenericWebhookTriggeredAction).requestPayload !==
    undefined
  );
}

export type FilterEventTriggeringCondition = {
  eventType: EventTriggeringConditionType;
  filter: string;
};
export type TriggeringCondition = FilterEventTriggeringCondition;

export type CreatedByUser = {
  username: string;
  id: string;
};

export type Trigger = {
  name: string;
  id: string;
  createdAt: string;
  enabled: boolean;
  description: string;
  createdBy?: CreatedByUser;
  triggerScope: TriggerScope;
  triggeringCondition: TriggeringCondition;
  triggeredAction?: TriggeredAction;
};

export type TriggerDetails = {
  id: string;
  name: string;
  scopeType: TriggerScopeType;
  scopeID: string;
};
